import { useCallback, useRef } from 'react'

export const useDoubleClick = (doubleClickCallback: () => void, singleClickCallback?: (event: React.MouseEvent) => void, delay: number = 300) => {
  const clickCount = useRef(0)
  const timeoutRef = useRef<NodeJS.Timeout | null>(null)

  const handleClick = useCallback((event: React.MouseEvent) => {
    clickCount.current += 1

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    if (clickCount.current === 2) {
      clickCount.current = 0
      event.stopPropagation()
      doubleClickCallback()
      return
    }

    timeoutRef.current = setTimeout(() => {
      if (clickCount.current === 1 && singleClickCallback) {
        singleClickCallback(event)
      }
      clickCount.current = 0
    }, delay)
  }, [doubleClickCallback, singleClickCallback, delay])

  const cleanup = useCallback(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }
  }, [])

  return {
    onDoubleClick: handleClick,
    cleanup,
  }
}
